import safeUrl from "@/components/features/widgets/safe-url.js";

// generic: універсальна смуга без картинок. position top → in-flow (як topbar),
// bottom → фіксований футер. Кнопка опційна (без buttonText — без кнопки).
export default {
	name	: "generic-widget",
	props	: {
		widget: {
			type		: Object,
			required	: true,
		},
	},
	computed: {
		variables() {
			return this.widget && this.widget.variables ? this.widget.variables : {};
		},
		text() {
			return this.variables.text || "";
		},
		buttonText() {
			return this.variables.buttonText || "";
		},
		hasButton() {
			return Boolean(this.buttonText);
		},
		linkUrl() {
			return safeUrl(this.variables.linkUrl);
		},
		bgColor() {
			return this.variables.bgColor || "#D5F174";
		},
		textColor() {
			return this.variables.textColor || "#000000";
		},
		position() {
			return this.variables.position === "bottom" ? "bottom" : "top";
		},
		positionClass() {
			return `generic-widget--${this.position}`;
		},
		closable() {
			return this.variables.closable !== false;
		},
		rootStyle() {
			return {
				backgroundColor : this.bgColor,
			};
		},
		textStyle() {
			return {
				color : this.textColor,
			};
		},
		buttonStyle() {
			return {
				color			: this.textColor,
				borderColor	: this.textColor,
			};
		},
	},
	methods: {
		onDismiss() {
			this.$emit("dismiss");
		},
	},
};
